export const PIXIESET_MAX_JPEG_UPLOAD_BYTES = 100 * 1024 * 1024

export const isPixiesetJpegOverUploadLimit = (byteLength: number) =>
	byteLength > PIXIESET_MAX_JPEG_UPLOAD_BYTES
